import { css } from 'styled-components';
import {
  grid, gridUnit, getTypography, TypographyName, getSpacing, SpacingName, ThemedFunctor, FontWeight,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)};
  border-top: 1px solid ${theme.palettes.neutrals.light};
`;

export const content: ThemedFunctor = ({
  theme,
}) => css`
  ${grid(theme)}
  ${getSpacing.margin(theme, [SpacingName.ZERO, SpacingName.NEGATIVE_SMALL])};
`;

export const block: ThemedFunctor = ({
  theme,
}) => css`
  ${gridUnit(theme, { size: { MD: 1 / 2 } })}
  ${getSpacing.marginTop(theme, SpacingName.SMALL)};
  ${getSpacing.padding(theme, [SpacingName.ZERO, SpacingName.SMALL])};

  &:last-of-type {
    text-align: right;
  }
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALL)}
  font-weight: ${FontWeight.BOLD};
  text-transform: uppercase;
`;

export const article: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}
`;
